
import { Component, Vue } from "vue-property-decorator";
import { AppModule } from "@/store/modules/app";
import { UserModule } from "@/store/modules/user";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import Hamburger from "@/components/Hamburger/index.vue";
import { isExternal } from "@/lib/validate";
import appconst from "@/lib/appconst";

@Component({
  name: "Navbar",
  components: {
    Breadcrumb,
    Hamburger
  }
})
export default class extends Vue {
  get sidebar() {
    return AppModule.sidebar;
  }

  get device() {
    return AppModule.device.toString();
  }

  get avatar() {
    if (UserModule.user.avatar) {
      if (isExternal(UserModule.user.avatar)) {
        return UserModule.user.avatar;
      }

      return appconst.remoteServiceBaseUrl + UserModule.user.avatar;
    }
    return require("@/assets/images/avatar.gif");
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false);
  }

  private async logout() {
    await UserModule.LogOut();
    location.reload();
  }
}
